export const formatQueryParams = (
  payload: Record<string, any>
): URLSearchParams => {
  // Keep all params except null/undefined and empty strings (preserve falsy values like false and 0)
  const paramsEntries = Object.entries(payload).filter(([, value]) => {
    if (value === null || value === undefined) return false;
    if (typeof value === 'string' && value.length === 0) return false;
    return true;
  });

  // Serialize params
  const serializedParams = new URLSearchParams();

  paramsEntries.forEach(([paramKey, paramValue]) => {
    serializedParams.append(paramKey, paramValue);
  });
  return serializedParams;
};

// to replace values like "{tenantId}" / "${internalDepotId}" etc. in url string
export const getUrlWithParams = (
  url: string,
  params: Record<string, string> = {}
): string => {
  let formattedUrl = url;

  Object.entries(params).forEach(([key, value]) => {
    formattedUrl = formattedUrl.replace(`{${key}}`, value);
  });

  return formattedUrl;
};
